module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info widget-block",
    class: {
      'not-close': _vm.notClose, 'mult': _vm.multiselect === true
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.curList,
      "showLabels": false,
      "allowEmpty": false,
      "searchable": _vm.curList && _vm.curList.length > 15,
      "multiple": _vm.multiselect === true,
      "label": "name",
      "track-by": "id",
      "placeholder": ""
    },
    on: {
      "open": _vm.OnOpen,
      "input": _vm.OnSelect
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [(_vm.name === 'server_view_type' && props.option.id) ? _c('span', {
          class: 'color-type-' + String(props.option.id),
          staticStyle: {
            "font-size": "13px"
          }
        }, [_vm._v("●")]) : _vm._e(), _vm._v("\n\t\t\t" + _vm._s(props.option.name) + "\n\t\t")]
      }
    }]),
    model: {
      value: (_vm.curValue),
      callback: function($$v) {
        _vm.curValue = $$v
      },
      expression: "curValue"
    }
  }), _vm._v(" "), (!_vm.notClose) ? _c('button', {
    staticClass: "btn-close-filter close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('closeFilter')
      }
    }
  }, [_vm._v("×")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ec7b46"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/filterSelect.vue
// module id = 481
// module chunks = 0